import { render, staticRenderFns } from "./CourseBoxItem.vue?vue&type=template&id=fd84097c&scoped=true&"
import script from "./CourseBoxItem.vue?vue&type=script&lang=js&"
export * from "./CourseBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseBoxItem.vue?vue&type=style&index=0&id=fd84097c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd84097c",
  null
  
)

export default component.exports